// Format phone number to (XXX) XXX-XXXX
export function formatPhoneNumber(value) {
  const digits = value.replace(/\D/g, '');
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

// Get digits only from phone number
export function getPhoneDigits(phone) {
  return phone.replace(/\D/g, '');
}

// Format date to MM/DD/YYYY
export function formatDate(value) {
  const digits = value.replace(/\D/g, '');
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
}

// Format height
export function formatHeight(feet, inches) {
  return `${feet} feet ${inches} inches`;
}

// Parse height string
export function parseHeight(heightString) {
  const match = heightString.match(/(\d+)\s*feet\s*(\d+)\s*inches?/i);
  if (match) {
    return {
      feet: parseInt(match[1]),
      inches: parseInt(match[2])
    };
  }
  return { feet: 5, inches: 0 };
}
